/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRateAggregationTrendResult extends models.BillingAggregationTrendResult {
    getFixupPrototypeFunction() { return BillingRateAggregationTrendResult.fixupPrototype; }

    static newInstance(model: Partial<BillingRateAggregationTrendResult>): BillingRateAggregationTrendResult {
        let obj = Object.assign(new BillingRateAggregationTrendResult(), model);
        BillingRateAggregationTrendResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRateAggregationTrendResult>): BillingRateAggregationTrendResult {
        if (!model) return null;
        return BillingRateAggregationTrendResult.newInstance(<BillingRateAggregationTrendResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRateAggregationTrendResult) {
        if (!obj) return;

        models.BillingRateAggregationTrendResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRateAggregationTrendResult): boolean {
        if (models.BillingAggregationTrendResult.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRateAggregationTrendResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
